import {
  HEX_292D38,
  HEX_292D39,
  HEX_646A7E,
  HEX_9BA4B6,
  HEX_ADB5C7,
  HEX_DCDFE6,
} from '@tanium/colors';
import { Background2, defineColor, Text3 } from '@tanium/react-theme-definition';

export const Text = defineColor([HEX_292D38, HEX_ADB5C7]);
export const OfText = Text3;

export const CompleteText = defineColor([HEX_292D39, HEX_9BA4B6]);
export const CompleteSubtext = defineColor([HEX_646A7E, HEX_9BA4B6]);

export const SelectedCountsFill = Background2;
export const SelectedCountsText = defineColor([HEX_292D38, HEX_DCDFE6]);
